import React, { useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../css/reservoir.css';

const ContactUs = () => {
    const underlineRef = useRef(null);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (underlineRef.current) {
                underlineRef.current.classList.add('animate');
            }
        }, 50);
        return () => clearTimeout(timer);
    }, []);

    // Add intersection animation for scroll reveal
    useEffect(() => {
        const observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('visible');
                    }
                });
            },
            { threshold: 0.1 }
        );

        const targets = document.querySelectorAll('.animate-slide');
        targets.forEach(target => observer.observe(target));

        return () => {
            targets.forEach(target => observer.unobserve(target));
        };
    }, []);

    return (
        <>
            {/* Hero Section */}
            <div className="container-fluid reservoir-bg d-flex align-items-end" style={{ minHeight: '85vh', padding: 0,top:'-122px' }}>
                <div className="container reservoir-content">
                    <div className="row">
                        <div className="col-lg-6 col-md-8 col-12 reservoir-text">
                            <h1 className="reservoir-title text-white">Reservoir Management</h1>
                            <h2 className="reservoir-subtitle">Petrochoice Integrated Services</h2>
                            <div className="reservoir-underline" ref={underlineRef}></div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Reservoir Management Section */}
            <section className="py-5 reservoir-section">
                <div className="container">
                    <div className="row align-items-center g-5">

                        {/* Text Left */}
                        <div className="col-lg-6 animate-slide">
                            <h2 className="fw-bold mb-3">Reservoir Management</h2>
                            <p className="fs-5 text-muted">
                                Reservoir management, a cornerstone of the oil and gas industry, assumes critical importance in maximizing hydrocarbon recovery and optimizing asset longevity. Our comprehensive reservoir management services employ cutting-edge techniques, encompassing reservoir characterization, dynamic modeling, production forecasting, and strategic field development planning.
                            </p>
                            <p className="fs-5 text-muted">
                                Through advanced reservoir engineering, including Enhanced Oil Recovery (EOR) methods, reservoir simulation, and pressure transient analysis, we meticulously analyze and simulate reservoir behavior. This empowers our clients with precise insights into reservoir dynamics and informs informed decisions.
                            </p>
                            <p className="fs-5 text-muted">
                                Our commitment to continual improvement, coupled with a tailored approach to each unique reservoir challenge, underscores our dedication to achieving production optimization and contributing to long-term operational success.
                            </p>
                        </div>

                        {/* Image Right */}
                        <div className="col-lg-6 animate-slide delay">
                            <img
                                src="/assets/reservoir2.jpg" // ✅ Ensure the image is in public/assets/reservoir.png
                                alt="Reservoir Management"
                                className="img-fluid"
                                style={{ maxHeight: '480px', objectFit: 'cover' }}
                            />
                        </div>
                    </div>
                </div>
            </section>

            <section className="py-5 reservoir-carousel-section">
                <div className="container">
                    <h3 className="fw-bold text-center mb-4" style={{ color: '#0c61c0' }}>
                        Reservoir Visualization Gallery
                    </h3>

                    <div className="position-relative">
                        {/* Carousel Container */}
                        <div className="d-flex overflow-hidden" id="scrollContainer" style={{ scrollBehavior: 'smooth' }}>
                            <div className="d-flex flex-nowrap" style={{ gap: '1rem' }}>
                                <img src="/assets/reservoir.png" alt="1" className="img-fluid rounded" style={{ width: '33.33%' }} />
                                <img src="/assets/reservoir.png" alt="2" className="img-fluid rounded" style={{ width: '33.33%' }} />
                                <img src="/assets/reservoir.png" alt="3" className="img-fluid rounded" style={{ width: '33.33%' }} />
                                <img src="/assets/reservoir.png" alt="4" className="img-fluid rounded" style={{ width: '33.33%' }} />
                                <img src="/assets/reservoir.png" alt="5" className="img-fluid rounded" style={{ width: '33.33%' }} />
                                <img src="/assets/reservoir.png" alt="6" className="img-fluid rounded" style={{ width: '33.33%' }} />
                            </div>
                        </div>

                        {/* Arrows */}
                        <button
                            className="btn btn-light position-absolute top-50 start-0 translate-middle-y shadow"
                            onClick={() => scrollCarousel(-1)}
                            style={{ zIndex: 10 }}
                        >
                            <i className="bi bi-chevron-left"></i>
                        </button>
                        <button
                            className="btn btn-light position-absolute top-50 end-0 translate-middle-y shadow"
                            onClick={() => scrollCarousel(1)}
                            style={{ zIndex: 10 }}
                        >
                            <i className="bi bi-chevron-right"></i>
                        </button>
                    </div>
                </div>
            </section>



        </>
    );
};
const scrollCarousel = (direction) => {
    const container = document.getElementById('scrollContainer');
    const scrollAmount = container.offsetWidth / 3; // Scroll by one image width
    container.scrollBy({ left: direction * scrollAmount, behavior: 'smooth' });
  };
  
export default ContactUs;
